import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
    paymentRequested,
    clearErrorMessages,
    getPackagePricingRequest,
} from '../actions';
import {
    getPaymentError,
    getPaymentProgress,
    getActivePackgePrice,
    getActivePackge,
    getActivePackageKey,
    getActivePackageId,
    getPackagePricing,
    getPriceLoading,
} from '../selectors';
import TextInput from '../../../common/TextInput/';
import LoginBannerImage from '../../../icons/user-screen-banner.png';
import AmountBackground from '../../../icons/amount-background.png';
import BrandLogo from '../../../icons/litterati.svg';
import LoadingComponent from '../../../common/LoadingComponent';
import './styles.scss';
import { useLocation } from 'react-router';
import { CardNumberElement } from '@stripe/react-stripe-js';
import qs from 'query-string';
import CheckoutForm from './CheckoutFormSplit';
import { noop } from '../../../common/propTypes';

function Payments({
    packageName,
    packagePrice,
    packageKey,
    packageId,
    packageDuration,
    onPayment,
    errorMessage,
    paymentInProgress,
    clearErrorState,
    fetchPricing,
    priceLoading,
    pricing,
}) {
    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchPricing();
    }, []);

    const [cardHolderName, setCardHolderName] = useState('');
    const [error, setError] = useState(null);
    const [stripeClient, setStripeClient] = useState(null);
    const [stripeElements, setStripeElements] = useState(null);
    let packageError = null;
    const location = useLocation();

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={paymentInProgress || priceLoading} />
        </div>
    );

    const buttonText = paymentInProgress ? loader : 'Complete Sign Up';

    // TODO should be done via persist blacklist
    useEffect(() => {
        clearErrorState();
    }, []);

    const queryParams = qs.parse(location.search);

    if (queryParams.package && pricing) {
        if (pricing[queryParams.package.toUpperCase()]) {
            packageName = pricing[queryParams.package.toUpperCase()].name;
            packagePrice = pricing[queryParams.package.toUpperCase()].price;
            packageKey = pricing[queryParams.package.toUpperCase()].key;
            packageId = pricing[queryParams.package.toUpperCase()].pricingId;
            packageDuration = pricing[queryParams.package.toUpperCase()].period;
        } else {
            packageError = 'Selected package does not exist';
        }
    }

    const handleChange = (event, stripe, elements) => {
        setStripeClient(stripe);
        setStripeElements(elements);
        if (event.error) {
            setError(event.error.message);
        } else {
            setError(null);
        }
    };

    // Handle form submission.
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const card = stripeElements.getElement(CardNumberElement);
        const result = await stripeClient.createToken(card, {
            name: cardHolderName,
        });
        if (result.error) {
            // Inform the user if there was an error.
            setError(result.error.message);
        } else {
            setError(null);
            // Send the token to your server.
            onPayment(
                result.token,
                packageName,
                packagePrice,
                packageKey,
                packageId,
            );
        }
    };
    const newDate = new Date();

    return (
        <Fragment>
            <section className="login-block strip-block userScreens mb-5 h-100">
                <div
                    className="row mx-0 backgroundImage paymentsScreen"
                    style={{
                        backgroundImage: `url(${LoginBannerImage})`,
                    }}
                >
                    <div
                        className="col-md-6 col-lg-7 paymentsScreenMobile"
                        style={{
                            backgroundImage: `url(${LoginBannerImage})`,
                        }}
                    ></div>
                    <div className="col-md-6 pl-md-0 col-lg-5 mt-5">
                        <div className="userBox">
                            <div className="userBoxContent">
                                <div className="logo mt-3 mb-5">
                                    <img src={BrandLogo} alt="logo" />
                                </div>
                                {errorMessage && !paymentInProgress ? (
                                    <p>{errorMessage}</p>
                                ) : null}
                                {packageError && !paymentInProgress ? (
                                    <p>{packageError}</p>
                                ) : null}
                                <form onSubmit={handleFormSubmit}>
                                    <div className="filter-form">
                                        <h2 className="mb-4 userBoxTitle">
                                            Complete Registration
                                        </h2>
                                        <div
                                            className="amount-box"
                                            style={{
                                                background: `url(${AmountBackground}) no-repeat center center/ cover`,
                                            }}
                                        >
                                            <div className="container h-100">
                                                <div className="row h-100">
                                                    <div className="col-6 align-self-center">
                                                        <h3 className="amount-heading">
                                                            {packageName}
                                                        </h3>
                                                    </div>
                                                    <div className="col-6 align-self-center text-right">
                                                        <h3 className="amount">
                                                            ${packagePrice}
                                                            <sub className="amount-subscript">
                                                                {
                                                                    packageDuration
                                                                }
                                                            </sub>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <div className="customInput">
                                            <h3 className="titleStyle2">
                                                Card Information
                                            </h3>
                                            <div className="mb-3">
                                                <CheckoutForm
                                                    handleChange={handleChange}
                                                />
                                            </div>
                                            {error && (
                                                <p
                                                    className="alert alert-info"
                                                    role="alert"
                                                >
                                                    {error}
                                                </p>
                                            )}
                                        </div>

                                        <div className="customInput">
                                            <h3 className="titleStyle2">
                                                Name on Card
                                            </h3>
                                            <div className="input-group mb-3">
                                                <TextInput
                                                    type="text"
                                                    onChange={(event) =>
                                                        setCardHolderName(
                                                            event.target.value,
                                                        )
                                                    }
                                                    value={cardHolderName}
                                                    placeholder={'Name on Card'}
                                                    required="required"
                                                />
                                            </div>
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-custom btn-block"
                                            disabled={
                                                !stripeClient ||
                                                paymentInProgress ||
                                                packageError
                                                    ? true
                                                    : false
                                            }
                                        >
                                            {buttonText}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className="stripeMessage text-center">
                                Powered by <strong>Stripe</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <p className="copyrights-payment text-center">
                    &copy; Copyright {newDate.getFullYear()} Litterati
                </p>
            </footer>
        </Fragment>
    );
}

Payments.propTypes = {
    // function to be called when form is submitted
    onPayment: PropTypes.func.isRequired,

    // error message to be shown when something goes wrong with login request
    errorMessage: PropTypes.string,

    // Defining package name statically
    packageName: PropTypes.string,

    // Key associated to a package, required to be sent at the backend
    packageKey: PropTypes.string,

    // Defining package price statically
    packagePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    // Defining package duration statically
    packageDuration: PropTypes.string,

    // whether login has been requested
    paymentInProgress: PropTypes.bool,

    // function to clear error message
    clearErrorState: PropTypes.func.isRequired,
    fetchPricing: PropTypes.func,
    pricing: PropTypes.array,
    priceLoading: PropTypes.bool,
    packageId: PropTypes.string,
};

Payments.defaultProps = {
    errorMessage: 'null',
    paymentInProgress: false,
    fetchPricing: noop,
};

// Maintaining Store states
const mapStateToProps = (state) => {
    return {
        errorMessage: getPaymentError(state),
        paymentInProgress: getPaymentProgress(state),
        packageName: getActivePackge(state),
        packagePrice: getActivePackgePrice(state),
        packageKey: getActivePackageKey(state),
        packageId: getActivePackageId(state),
        pricing: getPackagePricing(state),
        priceLoading: getPriceLoading(state),
    };
};

// Store action dispatchers
const mapDispatchToProps = (dispatch) => {
    return {
        onPayment: (
            tokenCreds,
            packageName,
            packagePrice,
            packageKey,
            packageId,
        ) =>
            dispatch(
                paymentRequested(
                    tokenCreds,
                    packageName,
                    packagePrice,
                    packageKey,
                    packageId,
                ),
            ),
        clearErrorState: () => dispatch(clearErrorMessages()),
        fetchPricing: () => dispatch(getPackagePricingRequest()),
    };
};

// Connect redux store with the component
const ConnectedPayments = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Payments);

export default ConnectedPayments;
